//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, RabbitListener, ConciergeProxy, SagasHelper } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';

import ConfiguracionManager from '../../../Common/Managers/ConfiguracionManager';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

// ACTION TYPES
export const GET_SCREEN_DATA_EDITCONFIGURACION_STARTS = "GET_SCREEN_DATA_EDITCONFIGURACION_STARTS";
export const SET_USER_FUNCTIONS_EDITCONFIGURACION = 'SET_USER_FUNCTIONS_EDITCONFIGURACION';
export const GET_SCREEN_DATA_EDITCONFIGURACION_SUCCESS = 'GET_SCREEN_DATA_EDITCONFIGURACION_SUCCESS';
export const RESET_STATE_EDITCONFIGURACION = "RESET_STATE_EDITCONFIGURACION";
export const DO_TRANSACTION_EDITAR_CONFIGURACION_SUCCESS = 'DO_TRANSACTION_EDITAR_CONFIGURACION_SUCCESS';
export const DO_TRANSACTION_EDITAR_CONFIGURACION_FAILED = 'DO_TRANSACTION_EDITAR_CONFIGURACION_FAILED';
export const DO_TRANSACTION_EDITAR_CONFIGURACION_START = 'DO_TRANSACTION_EDITAR_CONFIGURACION_START';
export const CHECKBOX_VALUE_CHANGE_CONFIG_SESION_EDIT = 'CHECKBOX_VALUE_CHANGE_CONFIG_SESION_EDIT';
export const CONFIGURATION_TYPE_CHANGE = 'CONFIGURATION_TYPE_CHANGE';
export const RADIO_BUTTON_CHANGE_CONF_SESION_EDIT = 'RADIO_BUTTON_CHANGE_CONF_SESION_EDIT';
export const TEXT_CHANGE_CONF_SESION_EDIT = 'TEXT_CHANGE_CONF_SESION_EDIT';
export const PLATAFORMA_VALUE_CHANGE_CONF_SESION_EDIT = 'PLATAFORMA_VALUE_CHANGE_CONF_SESION_EDIT';
export const RADIO_CONTRASENIA_CHANGE_CONF_SESION_EDIT = 'RADIO_CONTRASENIA_CHANGE_CONF_SESION_EDIT';
export const ESCONDER_POPUP_EDITCONFIGURACION = 'ESCONDER_POPUP_EDITCONFIGURACION';
export const REDIRECT_OK_CONFIGURACION = 'REDIRECT_OK_CONFIGURACION';

/**
 * Variables globales
 */
let _dispatch, _currentScope = null;

/**
 * * Obtiene los datos para popular la pantalla.
 * @param {any} currentScope
 */
export function getScreenData(currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch) => {
        _currentScope = currentScope;
        _dispatch = dispatch;
        dispatch({ type: GET_SCREEN_DATA_EDITCONFIGURACION_STARTS });

        var currentScopeRequest = {
            "UserId": _currentScope.UserId,
            "ProductCode": _currentScope.ProductCode,
            "ProgramCode": _currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadScreenData(data), null, "GETFUNCTIONS", currentScopeRequest, null, "SEGURIDAD");
    }
}

/**
 * Vuelve el estado de la pantalla al inicial de la misma.
 * @param {any} currentScope
 */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: RESET_STATE_EDITCONFIGURACION });
    }
}

/**
 Esconde o muestra el popup de error.
 */
export function hidePopUp() {
    LogHelper.In(hidePopUp.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ESCONDER_POPUP_EDITCONFIGURACION });
    }
}

/**
 * Impacta en el state global la modificacion de un checkbox.
 * @param {any} currentScope
 */
export function checkboxChangeState(obj) {
    LogHelper.In(checkboxChangeState.name, obj);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: CHECKBOX_VALUE_CHANGE_CONFIG_SESION_EDIT, obj });
    }
}

/**
 * Impacta en el state la modificacion del tipo de configuracion.
 * @param {any} currentScope
 */
export function configurationTypeChange(oldConf) {
    LogHelper.In(configurationTypeChange.name, oldConf);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: CONFIGURATION_TYPE_CHANGE, oldConf });
    }
}

/**
 * Impacta en el state la modificacion de un radioButton.
 * @param {any} currentScope
 */
export function radioButtonChange(obj) {
    LogHelper.In(radioButtonChange.name, obj);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: RADIO_BUTTON_CHANGE_CONF_SESION_EDIT, obj });
    }
}

/**
 * Impacta en el state la modificacion de un campo textbox.
 * @param {any} currentScope
 */
export function textChangeState(obj) {
    LogHelper.In(textChangeState.name, obj);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: TEXT_CHANGE_CONF_SESION_EDIT, obj });
    }
}

/**
 * Impacta en el state la modificacion de ingresos por plataforma.
 * @param {any} currentScope
 */
export function plataformaValueChange(obj) {
    LogHelper.In(plataformaValueChange.name, obj);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: PLATAFORMA_VALUE_CHANGE_CONF_SESION_EDIT, obj });
    }
}

/**
 * Impacta en el state la modificacion de los radioButtons relacionados a la configuracion de la contraseña.
 * @param {any} currentScope
 */
export function radioButtonChangeContrasenia(obj) {
    LogHelper.In(radioButtonChangeContrasenia.name, obj);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: RADIO_CONTRASENIA_CHANGE_CONF_SESION_EDIT, obj });
    }
}

/**
 * Impacta en la base la nueva configuracion de contraseña.
 * @param {any} currentScope
 */
export function guardarConfiguracion(data) {
    LogHelper.In(guardarConfiguracion.name);

    return (dispatch) => {
        dispatch({ type: GET_SCREEN_DATA_EDITCONFIGURACION_STARTS });

        _dispatch = dispatch;

        let configuracion = {
            'ID': data.idConfiguracionPasswordSesion,
            'ID_CONF_PASSWORD_TYPE': data.idConfPasswordType,
            'ALFABETICA': data.alfabetica,
            'NUMERICA': data.numerica,
            'CARACTERES_ESPECIALES': data.caracteresEspeciales,
            'PERMITE_NROS_CONSECUTIVOS': data.permiteNrosConsecutivos,
            'PERMITE_LETRAS_CONSECUTIVAS': data.permiteLetrasConsecutivas,
            'PERMITE_REPETIR_POSICION': data.permiteRepetirPosicion,
            'PERMITE_CARACTERES_IGUALES': data.permiteCaracteresIguales,
            'CASE_SENSITIVE': data.caseSensitive,
            'CARACTERES_MINIMOS': data.caracteresMinimos != null ? data.caracteresMinimos : 0,
            'CANTIDAD_REPETICIONES': data.cantidadRepeticiones != null ? data.cantidadRepeticiones : 0,
            'MAX_DIAS_INACTIVIDAD': data.maxDiasInactividad != null ? data.maxDiasInactividad : 0,
            'MAX_DIAS_CADUCIDAD': data.maxDiasCaducidad != null ? data.maxDiasCaducidad : 0,
            'MINUTOS_PERMITIDOS_INACTIVIDAD': data.minutosPermitidosInactividad != null ? data.minutosPermitidosInactividad : 0,
            'CANT_INTENTOS_FALLIDOS': data.cantIntentosFallidos != null ? data.cantIntentosFallidos : 0,
            'ALTA_AUTOMATICA': data.altaAutomatica,
            'VINCULAR_GRUPO_WINDOWS': data.vincularGrupoWindows,
            'SOLICITAR_CONTRASENIA': data.solicitarContrasenia,
            'SOLO_USUARIO_LOGGEADO': data.soloUsuarioLoggeado,    
            'TIPO_SEGURIDAD': data.tipoConfiguracion,
            'PLATAFORMAS': []
        };
          
        data.plataformas.forEach(function (element) {
            configuracion['PLATAFORMAS'].push({ ID: element.Id, DESCRIPCION: element.Descripcion, CANLOG: element.CanLog });
        });

        if (sessionStorage.getItem('PantallaCambios') == "true") {
            sessionStorage.removeItem('PantallaCambios');
        }

        LogHelper.Out(guardarConfiguracion.name);
        ConfiguracionManager.GuardarConfiguracion(configuracion, SagasHelper.GetSagasId, ejecutarPorEstado);
    }
}

/**
 * Redirecciona luego impactar los cambios.
 */
export function setRedirectOk() {
    LogHelper.In(setRedirectOk.name);

    if (sessionStorage.getItem('PantallaCambios') == "true") {
        sessionStorage.removeItem('PantallaCambios');
    }

    return (dispatch) => {
        _dispatch = dispatch;

        $("#discardChangesModal").modal('toggle');

        _setRedirect();
    }
}


/** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/

/**
 * Funcion que redirecciona a la pagina de Configuracion.
 */
function _setRedirect() {
    LogHelper.In(_setRedirect.name);

    _dispatch({ type: REDIRECT_OK_CONFIGURACION });
}

/**
 * Funcion callback de los datos principales para popular la pantalla.
 * @param {any} data
 */
function _loadScreenData(data) {
    LogHelper.In(_loadScreenData.name);

    let functions = data.SEGURIDAD;
    functions.forEach(p => { functions[p.Codigo_Funcion] = true; });

    _dispatch({ type: SET_USER_FUNCTIONS_EDITCONFIGURACION, functions });

    Engine1Proxy.AddDataSourcesRequests(null, 'GET_TIPO_PLATAFORMA', "Get", _currentScope.ProductCode, "SEGURIDAD", "Product", 1);
    Engine1Proxy.AddDataSourcesRequests(null, "GET_CONFIGURATION_PASSWORD_SESION", "Get", _currentScope.ProductCode, "SEGURIDAD", 1, "Product");
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_CONFIGURATION_PASSWORD_TYPE', "Get", _currentScope.ProductCode, "SEGURIDAD", "Product", 1);

    Engine1Proxy.Execute(_loadInitialStateData, null, null, "SEGURIDAD");

    LogHelper.Out(_loadScreenData.name, data);
}

/**
 * Funcion que parsea los datos recibidos del Engine1 para retornarlos a pantalla.
 * @param {any} data
 */
function _loadInitialStateData(data) {
    LogHelper.In(_loadInitialStateData.name, data);

    let result = {
        "GET_TIPO_PLATAFORMA": JSON.parse(data.GET_TIPO_PLATAFORMA).Recordset0.Rows,
        "GET_CONFIGURATION_PASSWORD_SESION": JSON.parse(data.GET_CONFIGURATION_PASSWORD_SESION).Recordset0.Rows,
        "GET_CONFIGURATION_PASSWORD_TYPE": JSON.parse(data.GET_CONFIGURATION_PASSWORD_TYPE).Recordset0.Rows
    }

    _dispatch({ type: GET_SCREEN_DATA_EDITCONFIGURACION_SUCCESS, result: result });

    LogHelper.Out(_loadInitialStateData.name, data);
}

/**
 * Callback de llamado a Sagas en el alta/edición de usuario
 * @param {any} result
 * @param {any} disconectCallback
 */
function ejecutarPorEstado(result, disconectCallback) {
    let message;

    switch (result.Estado) {
        case 2:
            _dispatch({ type: DO_TRANSACTION_EDITAR_CONFIGURACION_SUCCESS });

            break;

        case 3:
            _dispatch({ type: DO_TRANSACTION_EDITAR_CONFIGURACION_FAILED, saveErrorMessage: "Ha ocurrido un error en el servidor." });

            break;

        case 5:
            _dispatch({ type: DO_TRANSACTION_EDITAR_CONFIGURACION_FAILED, saveErrorMessage: "Ha ocurrido un error en el servidor." });

            break;

        default:

            _dispatch({ type: DO_TRANSACTION_EDITAR_CONFIGURACION_FAILED, saveErrorMessage: "Ha ocurrido un error en el servidor." });

            break;
    }

    disconectCallback();
}